<template>
  <div class="page-navigation">
    <div v-on:click="goingBack()" class="backward-btn">
      <div class="backward-btn-icon"></div>
    </div>
    <div class="page-counter">{{getCurrentPage}}/{{getBooklengthStore}}</div>
    <div v-on:click="goingForward()" class="forward-btn">
      <div class="forward-btn-icon"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from '@/firebase'

export default {
  name: 'PageNavigation',
    data (){
      return {
      }
    },
  components: {
  },
  computed: {
    ...mapGetters([
      'getCurrentPageStore',
      'getBooklengthStore',
      'getActiveUser',
      'getReaditId'
    ]),
    getCurrentPage() {
      return this.getCurrentPageStore + 1
    }
  },
  methods: {
    setCurrentPageFire(pageI) {
      var self = this
      if(this.getReaditId) {
        db.collection(`users`)
        .doc(self.getActiveUser)
        .collection('reading')
        .doc(self.getReaditId)
        .update({
          pageIndex: pageI
        }).then(function() {
        })
        .catch(function(error) {
            console.error("Error updating document field: ", error);
        });
      } else {
        var fireId = db.collection(`users`)
        .doc(this.getActiveUser)
        .collection('reading').doc()
        this.$store.commit('setCurrentpageReadingId', fireId.id)

        db.collection(`users`)
        .doc(this.getActiveUser)
        .collection('reading')
        .doc(fireId.id)
        .set({
          isbn: self.$route.params.book,
          pageIndex: pageI
        }).then(function() {

        })
        .catch(function(error) {
            self.$store.commit('setCurrentpageReadingId', '')
            console.error("Error adding document: ", error);
        });
      }
    },
    goingBack: function() {
      if(this.getCurrentPageStore > 0) {
        this.$store.commit('setCurrentpage', this.getCurrentPageStore -1)
        this.setCurrentPageFire(this.getCurrentPageStore)
      }
    },
    goingForward: function() {
      if(this.getCurrentPage < this.getBooklengthStore) {
        this.$store.commit('setCurrentpage', this.getCurrentPageStore +1)
        this.setCurrentPageFire(this.getCurrentPageStore)
      }
    }
  }
}
</script>

<style scoped>

  .page-counter {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    color: #494949;
    height: 40px;
    font-weight: bold;
  }

  .forward-btn-icon, .backward-btn-icon {
    margin: 0;
    padding: 0;
    border: 0;
    background-repeat: no-repeat;
    width: 25px;
    height: 25px;
  }

  .forward-btn-icon {
    background-image: url('../assets/icons/arrow-right-solid.svg');
  }

  .backward-btn-icon {
    background-image: url('../assets/icons/arrow-left-solid.svg');
  }

  .backward-btn, .forward-btn{
    border-radius: 0 50px 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 5px;
    background-color: white;
    height: 40px;
    width: 35px;
    cursor: pointer;
    
  }

  .backward-btn {
    border-radius: 50px 0 0 50px;
  }

  .page-navigation {
    box-shadow: -3px 3px 5px -2px rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    background-color: white;
    border: 1px solid whitesmoke;
    display: flex;
    flex-direction: row;
    position: fixed;
    align-items: center;
    justify-content: center;
    bottom: 20px;
    right: 10px;
  }

</style>
